<template>
  <tr
    v-if="bluredOrNotHidden"
    :class="{ active: isActive, hovered: showActions }"
    class="draggableBlock"
    data-block="Dynamic"
    @mouseover="mouseOver"
    @mouseleave="mouseOut"
    @click.stop="() => click()"
  >
    <td
      :class="{
        'block-borders': showDragBorder,
        'dragged-opacity': isCurrentElementDragged,
      }"
      style="word-break: break-word"
      align="left"
    >
      <blockActions
        v-if="showActions"
        :column-padding-x="columnPaddingX"
        :column-width="columnWidth"
        :disable-up-movement="disableUpMovement"
        :disable-down-movement="disableDownMovement"
        :block-height="blockHeight"
        :block-width="blockWidth"
        :is-active="isActive"
        :is-last-column="isLastColumn"
        :section-index="sectionIndex"
        :column-index="columnIndex"
        :block-index="blockIndex"
        :show-paste="showPaste"
        :copied="copied"
        @duplicate="copyBlock"
        @remove="deleteBlock"
        @moveUp="moveUp"
        @moveDown="moveDown"
        @copy="copyToClipboard"
      ></blockActions>
      <div :id="id" :style="hiddenStyle" class="ecmDynamicBlockPlaceholder">
        <svg
          class="img-1"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1"
            y="1"
            width="30"
            height="30"
            rx="5"
            stroke="#6DA8FF"
            stroke-width="2"
          />
          <path
            d="M10.0286 25.3085C9.57146 25.7717 8.96689 25.9996 8.36233 25.9996C7.75777 25.9996 7.15468 25.7701 6.69388 25.3107C5.77229 24.3917 5.77229 22.9023 6.69388 21.9833C7.1532 21.5224 7.75777 21.2945 8.36233 21.2945C8.96689 21.2945 9.56998 21.524 10.0308 21.9835C10.9502 22.9046 10.9502 24.3896 10.0286 25.3085ZM17.3276 25.9922C17.2833 25.9334 17.2465 25.9996 17.1433 25.9996C16.2195 25.9996 15.4409 25.2828 15.3797 24.3499C15.1821 20.3315 11.6874 16.8468 7.65455 16.5821C6.67987 16.5201 5.94039 15.6794 6.00379 14.7075C6.06715 13.7334 6.91875 13.0306 7.88531 13.0622C13.6257 13.4343 18.5979 18.3921 18.9739 24.119C19.0381 25.0953 18.3008 25.9334 17.3276 25.9922ZM24.3582 25.9996C24.3346 25.9991 24.3096 25.9996 24.2211 25.9996C23.2774 25.9996 22.4944 25.2578 22.4538 24.3087C22.1936 16.4866 15.5434 9.85539 7.69878 9.46575C6.72558 9.4878 5.96398 8.67177 6.00453 7.694C6.04582 6.72359 6.88041 5.94431 7.84624 6.00312C17.4824 6.40519 25.6514 14.5531 25.9905 24.0955C26.0938 25.1395 25.3388 26.0217 24.3582 25.9996Z"
            fill="#6DA8FF"
          />
        </svg>

        <svg
          class="img-2"
          width="32"
          height="32"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="2" y="2" width="32" height="32" rx="6" fill="#6DA8FF" />
          <rect
            x="1"
            y="1"
            width="34"
            height="34"
            rx="7"
            stroke="white"
            stroke-opacity="0.4"
            stroke-width="2"
          />
          <path
            d="M12.0286 27.3085C11.5715 27.7717 10.9669 27.9996 10.3623 27.9996C9.75777 27.9996 9.15468 27.7701 8.69388 27.3107C7.77229 26.3917 7.77229 24.9023 8.69388 23.9833C9.1532 23.5224 9.75777 23.2945 10.3623 23.2945C10.9669 23.2945 11.57 23.524 12.0308 23.9835C12.9502 24.9046 12.9502 26.3896 12.0286 27.3085ZM19.3276 27.9922C19.2833 27.9334 19.2465 27.9996 19.1433 27.9996C18.2195 27.9996 17.4409 27.2828 17.3797 26.3499C17.1821 22.3315 13.6874 18.8468 9.65455 18.5821C8.67987 18.5201 7.94039 17.6794 8.00379 16.7075C8.06715 15.7334 8.91875 15.0306 9.88531 15.0622C15.6257 15.4343 20.5979 20.3921 20.9739 26.119C21.0381 27.0953 20.3008 27.9334 19.3276 27.9922ZM26.3582 27.9996C26.3346 27.9991 26.3096 27.9996 26.2211 27.9996C25.2774 27.9996 24.4944 27.2578 24.4538 26.3087C24.1936 18.4866 17.5434 11.8554 9.69878 11.4657C8.72558 11.4878 7.96398 10.6718 8.00453 9.694C8.04582 8.72359 8.88041 7.94431 9.84624 8.00312C19.4824 8.40519 27.6514 16.5531 27.9905 26.0955C28.0938 27.1395 27.3388 28.0217 26.3582 27.9996Z"
            fill="white"
          />
        </svg>

        <br /><br />
        {{ dynamicIdentifier }}.{{ dynamicContent }}
      </div>
    </td>
  </tr>
</template>

<script lang="ts" setup>
  import blockProperties from "@/composables/useBlockProperties";
  import blockActions from "./blockActions.vue";
  import { computed } from "vue";

  const props = defineProps<{
    block: any;
    columnIndex: number;
    sectionIndex: number;
    blockIndex: number;
    isLocked: boolean;
  }>();

  const {
    showActions,
    showPaste,
    blockHeight,
    blockWidth,
    id,
    bluredOrNotHidden,
    hiddenStyle,
    isActive,
    disableUpMovement,
    disableDownMovement,
    columnPaddingX,
    columnWidth,
    isCurrentElementDragged,
    showDragBorder,
    isLastColumn,
    copied,
    mouseOver,
    mouseOut,
    click,
    copyBlock,
    deleteBlock,
    moveUp,
    moveDown,
    copyToClipboard,
  } = blockProperties(props);

  const dynamicIdentifier = computed(() => {
    return props.block.identifier
      .replace("<!--[CDATA[", "")
      .replace("]]-->", "");
  });

  const dynamicContent = computed(() => {
    return props.block.content.replace("<!--[CDATA[", "").replace("]]-->", "");
  });
</script>

<style lang="scss">
  .ecmDynamicBlockPlaceholder {
    color: rgb(109, 168, 255);
    outline: 2px solid rgb(194, 221, 255);
    background-color: #e7f3ff;
    padding: 40px 25px;
    text-align: center;
    font: var(
      --chip-font,
      var(--chip-font-weight, var(--font-normal))
        var(--chip-font-size, var(--font-xs)) / var(--chip-font-line-height, 1)
        var(--chip-font-family, var(--font-family-primary))
    );

    .img-2 {
      display: none;
    }

    &:hover {
      background-color: rgb(206, 231, 255) !important;
      color: rgb(72, 131, 255) !important;
      border-radius: 0px;
      .img-1 {
        display: none;
      }

      .img-2 {
        display: inline-block;
      }
    }
  }
</style>
